import React from "react";
import OverView from "./OverView";
import WarnUp from "./WarnUp";
import Traning from "./Traning";

const AddNewWorkOut = ({
  excerciseData,
  setSelectedImageUrl,
  setSelectedVideoUrl,
  disabled,
  weekIndex,
  dayIndex,
  setUploadedJson
}) => {
  // console.log("exerciseData",exerciseData)
  const warmUpCategory = excerciseData?.categories?.find(
    (category) => category.sub_category === "Warm up"
  );
  const trainingCategory = excerciseData?.categories?.find(
    (category) => category.sub_category === "Training"
  );
  return (
    <div
      className="tab-pane active"
      id="inner-one"
      role="tabpanel"
      aria-labelledby="inner-one-tab"
      tabIndex="0"
    >
      <div className="row mt-3">
        <div className="row">
          <OverView exerciseData={excerciseData} disabled={disabled} weekIndex={weekIndex} dayIndex={dayIndex} setUploadedJson={setUploadedJson} />
          {warmUpCategory?.exercises?.map((exercise, index) => {
            return (
              <WarnUp
                exercise={exercise}
                warmUpCategory={warmUpCategory.sub_category}
                setSelectedImageUrl={setSelectedImageUrl}
                setSelectedVideoUrl={setSelectedVideoUrl}
                disabled={disabled}
              />
            );
          })}


          {trainingCategory?.exercises?.map((exercise, exerciseindex) => {
            return (
              <Traning
                weekIndex={weekIndex}
                dayIndex={dayIndex}
                setUploadedJson={setUploadedJson}
                exerciseindex={exerciseindex}
                exercise={exercise}
                trainingCategory={trainingCategory.sub_category}
                setSelectedImageUrl={setSelectedImageUrl}
                setSelectedVideoUrl={setSelectedVideoUrl}
                disabled={disabled}
              /> 
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AddNewWorkOut;
